import config from "@Config/index";

const getCashBackValue = (currency = "pound") => {
  switch (currency) {
    case "dollar":
      return {
        cashbackCurrency: "$",
        cashbackValue: 25,
        video: `${config.IMAGE_STATIC_URL}/VidUS.mp4`,
      };
    case "aud":
      return {
        cashbackCurrency: "AU$",
        cashbackValue: 25,
        video: `${config.IMAGE_STATIC_URL}/VidAustralia.mp4`,
      };
    case "cad":
      return {
        cashbackCurrency: "CA$",
        cashbackValue: 25,
        video: `${config.IMAGE_STATIC_URL}/VidUS.mp4`,
      };
    case "euro":
      return {
        cashbackCurrency: "€",
        cashbackValue: 20,
        video: `${config.IMAGE_STATIC_URL}/VidEurope.mp4`,
      };
    case "pound":
    default:
      return {
        cashbackCurrency: "£",
        cashbackValue: 20,
        video: `${config.IMAGE_STATIC_URL}/VidUK.mp4`,
      };
  }
};

export default getCashBackValue;
